module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "templates",
    attrs: {
      "id": "templates-new"
    }
  }, [_c('back-link'), _c('h1', [_vm._v(_vm._s(_vm.$t('template.title.edit')))]), _c('br'), _c('template-form', {
    attrs: {
      "options": _vm.options,
      "template": _vm.template,
      "default_template_kind": _vm.template.kind
    },
    on: {
      "validation-success": _vm.saveConfirmation
    }
  }), _c('confirm-modal', {
    attrs: {
      "id": "confirm-edit-template",
      "title": _vm.$t('template.actions.new'),
      "confirm_text": _vm.$t('general.actions.confirm'),
      "confirm_class": "btn-primary"
    },
    on: {
      "confirm-modal-confirm": _vm.save
    }
  }, [_c('br'), _c('div', {
    staticClass: "text-left"
  }, [_c('div', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.optionsLabel)
    }
  }), _c('div', {
    staticClass: "modal-update-option"
  }, [_c('div', {
    staticClass: "checkbox-inline",
    on: {
      "click": function($event) {
        _vm.update_flow_templates = true
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.update_flow_templates
    }
  }), _c('label', [_vm._v(_vm._s(_vm.$t('template.actions.updateAtFlows')))])])]), _c('div', {
    staticClass: "modal-update-option"
  }, [_c('div', {
    staticClass: "checkbox-inline",
    on: {
      "click": function($event) {
        _vm.update_flow_templates = false
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": !_vm.update_flow_templates
    }
  }), _c('label', [_vm._v(_vm._s(_vm.$t('template.actions.createOnEdit')))])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9893b0a8!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/templates/edit.vue
// module id = 1195
// module chunks = 1